// SectionHeader.js
import React from 'react';
import './SectionHeader.css';

/**
 * Unified section header component with icon and title
 * @param {Object} props
 * @param {React.Component} props.icon - React icon component (e.g., FaUser)
 * @param {string} props.title - Section title text
 * @param {string} props.variant - Optional variant for different color schemes
 * @param {string} props.className - Optional additional CSS classes
 */
const SectionHeader = ({ icon: Icon, title, variant = 'default', titleGradient = true, className = '' }) => {
  return (
    <div className={`section-header ${variant} ${titleGradient ? 'title-gradient' : 'title-no-gradient'} ${className}`}>
      <div className={`section-icon-wrapper ${variant}`}>
        {Icon && <Icon className="section-icon" />}
      </div>
      <h2>{title}</h2>
    </div>
  );
};

export default SectionHeader;